const getElementSize = (element: string | Blob) => {
  if (typeof element === "string") {
    return element.length;
  }
  if (element instanceof Blob) {
    return element.size;
  }
  return 0;
};

export const estimateFormDataSize = (formData: FormData) => {
  return formData.entries().reduce((accum, [key, value]) => {
    return (accum += key.length + getElementSize(value));
  }, 0);
};

export const splitFormData = (formData: FormData, maxSize: number) => {
  const chunks = [];
  let currentFormData = new FormData();
  let currentSize = 0;

  for (const [key, value] of formData.entries()) {
    const entrySize = key.length + getElementSize(value);

    if (currentSize + entrySize > maxSize) {
      chunks.push(currentFormData);
      currentFormData = new FormData();
      currentSize = 0;
    }

    currentFormData.append(key, value);
    currentSize += entrySize;
  }

  if ([...currentFormData.entries()].length > 0) {
    chunks.push(currentFormData);
  }

  return chunks;
};
